import { useAuthorization } from '../../../authorization/useAuthorization';
import { ACCESS } from '../../../constants/authz/accessPresets.constants';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { globalpermissions } from '../../../Services/Permission';

export default function useAnalyticsPermissions() {
  const { can, isAuthzV2Enabled } = useAuthorization();
  const constActions = ConstantActions();

  if (isAuthzV2Enabled) {
    const hasViewAccess = can(ACCESS.ANALYTICS_VIEW) || can(ACCESS.REPORTING_VIEW);
    return {
      canView: hasViewAccess,
      canCreate: can(ACCESS.ANALYTICS_CREATE) || hasViewAccess,
      canDelete: can(ACCESS.ANALYTICS_DELETE),
      canExport: can(ACCESS.ANALYTICS_EXPORT) || hasViewAccess,
      canViewRecords: can(ACCESS.ANALYTICS_RECORDS) || hasViewAccess,
      canViewWhatsapp: can(ACCESS.ANALYTICS_WHATSAPP) || hasViewAccess,
      canViewIntervene: can(ACCESS.ANALYTICS_INTERVENE) || hasViewAccess,
    };
  }

  const routes = globalpermissions.managementRoutes || {};
  const hasReporting = constActions.userHasPermission([
    globalpermissions?.reports?.viewReport,
    globalpermissions?.leadFormPage?.report,
    globalpermissions?.leadFormPage?.analytics,
    globalpermissions?.pagePermissions?.reporting,
    globalpermissions?.pagePermissions?.entityReportPageAccess,
    globalpermissions?.pagePermissions?.campaignReportPageAccess,
    'can_view_report_sidebar',
    'can_view_report',
    'can_view_analytics',
    'can_view_analsytics',
    'can_create_report',
    'can_create_custom_reports',
    routes.manageReporting,
  ]);

  return {
    canView: hasReporting,
    canCreate: hasReporting,
    canDelete: hasReporting,
    canExport: hasReporting,
    canViewRecords: hasReporting,
    canViewWhatsapp: hasReporting,
    canViewIntervene: hasReporting,
  };
}
